import React from 'react';
import TypingEffect from '../TypingEffect/TypingEffect';
import Carousel from '../Carousel/Carousel';
import coverImage from "assets/images/bonzini_worlds.jpg";

const Banner = () => {
    return (
      <>
        <div id='home'
          className="hero min-h-screen !px-0 bg-blue-400"
          style={{
            backgroundImage: `url(${coverImage})`, // Replace with the actual image path
            backgroundSize: 'cover', // Ensures the image covers the div
            backgroundPosition: 'center', // Centers the image
            backgroundRepeat: 'no-repeat' // Prevents the image from repeating
          }}
        >
            <div className='hero-overlay bg-opacity-60 bg-opacity-80'></div>
            <div className="hero-content mt-32 text-center text-neutral-content">
                <div className='grid grid-cols-1 md:grid-cols-2 pt-16 gap-24'>
                    <div>
                        <TypingEffect/>
                    </div>
                    <div>
                        <Carousel/>
                    </div>
                </div>
            </div>
        </div>
      </>
    );
};

export default Banner;